module.exports = __webpack_public_path__ + "static/media/maravista.31925af0.webp";